import React from "react";
import { Newspaper, ArrowUpRight, FileDown, Megaphone } from "lucide-react";
import useReveal from "../hooks/useReveal";
import ContactSection from "../components/ContactSection";
import { NEWS_PAGE, IMAGES, META } from "../mock";
import useDocMeta from "../hooks/useDocMeta";

export default function News() {
  useReveal();
  useDocMeta(META.news);
  const f = NEWS_PAGE.featured;
  const g = NEWS_PAGE.gladstone;
  return (
    <div>
      <section className="relative pt-36 pb-12 sm:pt-44 sm:pb-14 bg-gradient-to-b from-brand-50 to-sand-50 overflow-hidden" data-testid="news-gladstone-block">
        <div className="absolute -top-24 -right-16 h-80 w-80 rounded-full bg-brand-200/40 blur-3xl" />
        <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-12 items-center">
          <div className="rounded-[2rem] overflow-hidden shadow-[0_40px_90px_-45px_rgba(31,56,53,0.5)] aspect-[4/3]">
            <img src={g.image} alt="AwareHub is coming to Gladstone" className="h-full w-full object-cover" />
          </div>
          <div>
            <span className="inline-flex items-center gap-2 text-brand-500 font-semibold tracking-[0.2em] text-xs uppercase">
              <Megaphone className="h-4 w-4" /> {g.eyebrow}
            </span>
            <h1 className="mt-4 font-display text-3xl sm:text-4xl lg:text-[2.7rem] leading-tight text-brand-900 text-balance">
              {g.title}
            </h1>
            <p className="mt-4 text-lg text-brand-900/70">{g.subtitle}</p>
          </div>
        </div>
      </section>

      <section className="relative py-12 sm:py-16 bg-white overflow-hidden" data-testid="news-bundaberg-block">
        <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="inline-flex items-center gap-2 text-brand-500 font-semibold tracking-[0.2em] text-xs uppercase">
              <Newspaper className="h-4 w-4" /> In the news
            </span>
            <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-[2.7rem] leading-tight text-brand-900 text-balance">
              {f.title}
            </h2>
            <p className="mt-4 text-lg text-brand-900/70">{f.subtitle}</p>
            <a
              href={f.linkUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-7 inline-flex items-center gap-2 rounded-full bg-cta-500 hover:bg-cta-600 text-white px-6 py-3 font-semibold transition-colors"
            >
              {f.linkLabel} <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>
          <div className="rounded-[2rem] overflow-hidden shadow-[0_40px_90px_-45px_rgba(31,56,53,0.5)] aspect-[4/3]">
            <img src={IMAGES.beach} alt="AwareHub expands to Bundaberg" className="h-full w-full object-cover" />
          </div>
        </div>
      </section>

      <section className="py-12 sm:py-16 bg-brand-50">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <h2 className="font-display text-4xl sm:text-5xl text-brand-900 mb-10 reveal">Latest news</h2>
          <div className="grid md:grid-cols-3 gap-6">
            {NEWS_PAGE.articles.map((a, i) => (
              <article
                key={i}
                className="reveal flex flex-col bg-white rounded-3xl overflow-hidden border border-brand-100 shadow-[0_18px_45px_-38px_rgba(31,56,53,0.5)] hover:-translate-y-1.5 transition-transform duration-300"
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                {a.image && (
                  <div className="aspect-[16/10] overflow-hidden">
                    <img src={a.image} alt={a.source} className="h-full w-full object-cover" />
                  </div>
                )}
                <div className="p-7 flex flex-col flex-1">
                  <p className="text-xs font-semibold tracking-widest text-brand-500 uppercase">{a.source}</p>
                  <p className="mt-3 text-brand-900/80 leading-relaxed flex-1">{a.body}</p>
                  <a
                    href={a.linkUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-5 inline-flex items-center gap-2 font-semibold text-brand-600 hover:text-brand-700 transition-colors"
                  >
                    {a.linkLabel.toLowerCase().includes("download") ? <FileDown className="h-4 w-4" /> : <ArrowUpRight className="h-4 w-4" />}
                    {a.linkLabel}
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <ContactSection />
    </div>
  );
}
